import * as React from "react";
function SvgWarning(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M1.2 27l14-24.6c.4-.6 1.1-.6 1.5 0l14 24.6c.4.7 0 1.6-.8 1.6H2c-.8-.1-1.2-1-.8-1.6z"
        fill="#ffde00"
      />
      <path d="M30 29.5H2c-.7 0-1.3-.4-1.6-1-.4-.7-.4-1.5 0-2.1l14-24.6c.3-.6 1-1 1.6-1s1.3.4 1.6 1l14 24.6c.4.7.4 1.5 0 2.1-.3.7-.9 1-1.6 1zm-27.9-2H30v-.1L16 3 2.1 27.5z" />
      <path d="M13.9 24.5c0-.7.2-1.2.5-1.5.4-.3.9-.5 1.5-.5s1.1.2 1.5.5c.4.3.5.8.5 1.5 0 .6-.2 1.1-.5 1.5-.4.4-.9.5-1.5.5-.7 0-1.2-.2-1.5-.5-.3-.4-.5-.9-.5-1.5zm3.5-4h-2.9L14 9h4l-.6 11.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgWarning);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
